'use strict';

angular.module('ClinicApp').directive('doctorEducation', function($q, $timeout, OCDomUtil, DoctorService) {
  var YEAR_MAX = new Date().getFullYear();

  return {
    scope: {
      doctor: '=doctorEducation',
    },
    templateUrl: '/views/directives/_doctor-education.html',
    link: function($scope) {
      $scope.doctor.metadata = $scope.doctor.metadata || {};
      $scope.doctor.metadata.education = $scope.doctor.metadata.education || [];
      $scope.educationItem = {};

      $scope.toggleEditMode = function() {
        $scope.editMode = !$scope.editMode;
        if ($scope.editMode && OCDomUtil.isMobileScreen()) {
          $timeout(function() {
            OCDomUtil.scrollTo('.doctor-education .ibox-content-footer');
          });
        }
      };

      $scope.disableEditMode = function(form) {
        $scope.educationItem = {};
        form.$setPristine();
        form.$setValidity(null, true);
        form._submitted = false;
        $scope.editMode = false;
      };

      $scope.addEducationItem = function(form) {
        form._submitted = true;
        form.year.$setValidity('correct', true);
        if ($scope.educationItem.year < 1900 || $scope.educationItem.year > YEAR_MAX) {
          form.year.$setValidity('correct', false);
        }
        if (form.$invalid) {
          return $q.reject();
        }

        const education = [...$scope.doctor.metadata.education];
        education.push({
          degree: $scope.educationItem.degree,
          institution: $scope.educationItem.institution,
          year: $scope.educationItem.year,
        });

        return updateEducation(education).then(() => {
          $scope.disableEditMode(form);
        });
      };

      $scope.removeEducationItem = function(index) {
        const education = [...$scope.doctor.metadata.education];
        education.splice(index, 1);
        return updateEducation(education);
      };

      function updateEducation(education) {
        return DoctorService.updateDoctor($scope.doctor, {
          metadata: {
            education,
          },
        }).then(() => {
          $scope.doctor.metadata.education = education;
        });
      }
    },
  };
});
